export default __webpack_public_path__ + "static/media/egg3.461561f4.svg";